import apiService from '@/services/apiService';

const actions = {
  getBenefitTypes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit-type/find-all', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getBenefitTypesWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit-type/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postBenefitType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit-type', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putBenefitType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelian-club/benefit-type/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteBenefitType({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiService.delete(`paxelian-club/benefit-type/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;